export default __webpack_public_path__ + "static/home-slider-6-764bec78d6fb1887225afcda3a86efb9.jpg";